import Box from '@mui/material/Box';
import { Hero } from '../components/Hero';
import { Helmet } from 'react-helmet-async';
import {
  FamilyTreeSection,
  Feedbacks,
  Trust,
  HubSection,
  ContactSection,
  ProblemStatementSection,
} from '../components';
import { AppConfig } from '../../../core';

export function LandingPage() {
  return (
    <Box component="main">
      <Helmet>
        <title>Home | {AppConfig.appName}</title>
        <meta
          name="description"
          content="Preserve your family's heritage, stories, and migration journey in one secure digital home built for African diaspora families."
        />
        <meta property="og:title" content={`${AppConfig.appName} - Home`} />
        <meta
          property="og:description"
          content="An application for preserving heritage and connecting generations."
        />
      </Helmet>
      <Hero />
      <ProblemStatementSection />
      <FamilyTreeSection />
      <HubSection />
      <Feedbacks />
      <Trust />
      <ContactSection />
    </Box>
  );
}
